import {
  DialogActions as MuiDialogActions,
  DialogActionsProps as MuiDialogActionsProps,
} from '@mui/material';
import { Theme, css } from '@emotion/react';

const root = ({ spacing }: Theme) => css`
  padding: ${spacing(3)}px;
`;

export type DialogActionsProps = MuiDialogActionsProps;

/**
 * @deprecated Fine to use for Tock internal tools only. Please use `@tocktix/pantry` UI components for any new JCE admin tools.
 */
const DialogActions = (props: DialogActionsProps) => {
  return <MuiDialogActions css={root} {...props} />;
};

export default DialogActions;
